import { render, staticRenderFns } from "./WidgetShorcuts.vue?vue&type=template&id=80cf0fb2"
import script from "./WidgetShorcuts.vue?vue&type=script&lang=js"
export * from "./WidgetShorcuts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports